export { default } from "./PlayerDetailRightContainer";
